import styled from "styled-components";
import {Select, DatePicker} from "antd";
import {CloseOutlined, DownOutlined} from "@ant-design/icons";
export const SelectField = styled(Select)`
    width: 100%;
`;

export const DateRangePicker = styled(DatePicker)`
    width: 100%;
`;

export const MultiSelectValueText = styled.span`
    text-overflow: ellipsis;
    overflow: hidden;
    width: 160px;
    height: 1.2em;
    white-space: nowrap;
`;

export const MultiSelectDownIcon = styled(DownOutlined)`
    font-size: 12px;
    color: rgba(0, 0, 0, 0.25);
    margin-left: 10px;
`;

export const MultiSelectCloseIcon = styled(CloseOutlined)`
    font-size: 12px;
    color: rgba(0, 0, 0, 0.25);
    margin-left: 10px;
`;
